import { RESET_SEARCH } from '../types'
export const resetsearch = () => {

    return (dispatch) => {
        dispatch({ type: RESET_SEARCH});
    }
}